template =  require('./markdownbox.html.slim')
marked = require('marked')

angular.module('wbComponents').directive 'wbMarkdownbox',
['$sce', 'users', ($sce, users) ->
  replace: true
  restrict: "E"
  require: "ngModel"

  scope:
    model: "=ngModel"
    value: "="

  templateUrl: template

  link: ($scope, element, attrs) ->
    $scope.editing = false
    $scope.canEdit = !attrs.restrictEdit?

    if attrs.restrictEdit?
      $scope.canEdit = users.hasRole(attrs.restrictEdit)

    $scope.startEditing = ->
      return unless $scope.canEdit
      $scope.editing = true

    $scope.endEditing = ->
      $scope.editing = false

    $(element).on 'blur', 'textarea', (event) ->
      $scope.endEditing()

    $scope.$watch 'model', (content) ->
      if content? and content isnt ''
        $scope.markdownOutput = $sce.trustAsHtml marked(content)
      else
        $scope.markdownOutput = null
]
